import {
  Button,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CircularProgress
} from '@material-ui/core'
import DateRangeIcon from '@material-ui/icons/DateRange'
import i18n from 'i18next'
import { useState } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { formValueSelector, reduxForm, change, Field } from 'redux-form'
import { stepForward } from '../../../actions/apartments'
import ErrorMessage from '../../../components/Error/ErrorMessage'
import {
  ReduxCheckbox,
  ReduxDatePicker,
  ReduxFormField,
  ReduxGoogleAutocomplete
} from '../../../components/FormInput/ReduxWrappers'
// import ErrorMessage from '../../../components/Error/ErrorMessage'
//import customCloseIcon from '../../../images/customCloseIcon.svg'
import tick from '../../../images/Checkmark_VO.png'
import { runAIGenerationAndUpdateNotes } from '../../../services/openAI'
import {
  onlyNums,
  onlyNumsAndDecimals,
  charsSpace,
} from '../../../libs/normalize/information'
import { MuiClasses } from '../../../types'
import {
  ApartmentInformation,
  BuildingInfo,
  PropertyInfo
} from '../../../types/apartments'
import { AutocompleteOption } from '../../../types/autocomplete'
import { BasicFieldProps, ReduxForm } from '../../../types/forms'
import {
  BalconyOptions,
  BuildingTypeOptions,
  ConditionOptions,
  DishwasherOptions,
  KitchenOptions,
  LaundryMachineOptions,
  RoomOptions,
  WaterFeeBasis,
  WaterFeeBasisOptions
} from '../../../types/propValues/apartments'

import { StateInterface } from '../../../types/states'
import { showWaterFee } from '../../../utils/apartments'
import { energyCertifications } from '../../../utils/validation/energyCertifications'
  import {
    required,
    requiredLocation,
    isPostalCode,
    isStreetNumber,
    lessThanAvailableUntil,
    lessOrEqualThanFloors,
    moreOrEqualThanFloor,
    validatePostalArea,
    validateYear,
    yearAtLeast1699,
    isInvalidCharacters,
    isNumericOrEmpty
  } from '../../../utils/validation/forms'
import { arrayOfCities } from '../../../utils/validation/listOfCitiesForPostalArea'
//import { useDispatch } from 'react-redux'
//import Dialog from '../../Dialog'
import {
  MyApartmentRadio,
  MyInput,
  MyTextArea,
  ReduxFormSelect
} from '../../NewApplication/Fields'
// import FirstLinkModal from '../Modals/FirstLinkModal'
// import FourLinkModal from '../Modals/FourLinkModal'
// import SecongLinkModal from '../Modals/SecongLinkModal'
// import ThirdLinkModal from '../Modals/ThirdLinkModal'
import { BackButton } from '../Stepper/BackButton'
import NextStepButton from '../Stepper/NextStepButton'
import Suggest from '../Stepper/Steps/Suggest'
import SubmitButton from '../Stepper/SubmitButton'
import { AdditionalInfoFields } from './InfoFormFields'
import {
  checkboxProperties,
  getValuesAndLabels
} from './values/apartmentProperties'

interface ApartmentInformationFormProps
  extends WithTranslation,
  ReduxForm,
  ApartmentInformation {
  autocompleteLocation: undefined | AutocompleteOption | string
  updateApartmentInformation: (arg: any) => any
  isDisabled: boolean
  classes: MuiClasses
  t: i18n.TFunction
  changeFormValue: (field: string, value: string) => void
  currentStep: any
  doStepBack: () => void
  isMobile: any
  waterFeeBasis: WaterFeeBasis | undefined
  beforeLogin?: boolean
  doNextStep: any
  internetIncluded?: boolean;
  renovatedCheckBoxProperty?: boolean;
  hasElevator?: boolean;
  isFurnished?: boolean;
  hasBuiltInClosetCheckBoxProperty?: boolean;
  hasSaunaCheckBoxProperty?: boolean;
  petsAllowedCheckBoxProperty?: boolean;
  housingPropertySauna?: boolean;
  newProperty?: boolean;
  initialValues: any
}
const CheckBoxProperties = ({ t, isDisabled }: BasicFieldProps) => (
  <>
    <Grid item sm={12}>
      <Typography variant='body1' gutterBottom style={{ marginBottom: '15px' }}>
        {t('apartment.additionalProperties.feature')}
      </Typography>
    </Grid>
    <Grid container spacing={1}>
      {checkboxProperties.map(({ value, label }, index) => (
        // last 2 values are sm={12}, others are sm={4}
        <Grid item xs={6} sm={6} key={value}>
          <Field
            key={value}
            name={value}
            component={ReduxCheckbox}
            disabled={isDisabled}
            custom={true}
            label={t(label)}
          />
        </Grid>
      ))}
    </Grid>
  </>
)
const ApartmentInformationForm = ({
  classes,
  t,
  handleSubmit,
  submitting,
  error,
  updateApartmentInformation,
  isDisabled,
  autocompleteLocation,
  postalArea,
  postalCode,
  squareMeters,
  rooms,
  kitchen,
  buildYear,
  floor,
  floors,
  availableFromDate,
  buildingType,
  condition,
  doStepBack,
  storage,
  balcony,
  parking,
  heating,
  sauna,
  petsAllowed,
  dishwasher,
  laundryMachine,
  changeFormValue,
  waterFeeBasis,
  waterFee,
  currentStep,
  isMobile,
  beforeLogin,
  price,
  notes,
  doNextStep,
  district,
  //apartmentNumber,
  buildingLetter,
  streetNumber,
  damages,
  renovations,
  energyCertification,
  internetIncluded,
  renovatedCheckBoxProperty,
  hasElevator,
  isFurnished,
  hasBuiltInClosetCheckBoxProperty,
  hasSaunaCheckBoxProperty,
  petsAllowedCheckBoxProperty,
  initialValues,
}: ApartmentInformationFormProps) => {
  const getWaterFeeAdornment = (waterFeeBasis: WaterFeeBasis) => {
    const abbreviation =
      waterFeeBasis === 'perTenant' || waterFeeBasis === 'metered'
        ? 'perPersonPerMonth'
        : 'perMonth'
    return `€${i18n.t(`abbreviations.${abbreviation}`)}`
  }
  const [isLoading, setLoading] = useState(false)
  const [isEmpty, setIsEmpty] = useState(false)
  // Always show AI improvement button on step 7

  const addressInfoValues = {
    autocompleteLocation,
    postalArea,
    postalCode,
    streetNumber,
    district,
    // apartmentNumber,
    buildingLetter,
    floor,
    floors
  }
  const buildingInfo: BuildingInfo = {
    buildYear,
    buildingType,
    storage
  }
  const propertyInfoValues: PropertyInfo = {
    squareMeters,
    rooms,
    kitchen,
    balcony,
    condition,
    price
  }
  const additionalProps = {
    heating,
    sauna,
    parking,
    petsAllowed,
    dishwasher,
    laundryMachine
  }

  const handleGenerateAIText = async () => {
    try {
      setLoading(true)

      const address =
        typeof autocompleteLocation === 'string'
          ? autocompleteLocation
          : (autocompleteLocation && (autocompleteLocation as any).label) || ''

      const generatedNotes = await runAIGenerationAndUpdateNotes(
        undefined,
        undefined,
        {
          streetAddress: address,
          streetNumber,
          postalArea,
          postalCode,
          buildingType,
          rooms,
          kitchen,
          balcony,
          floor,
          floors,
          dishwasher,
          laundryMachine,
          internetIncluded,
          petsAllowedCheckBoxProperty,
          hasSaunaCheckBoxProperty,
          hasElevator,
          isFurnished,
          hasBuiltInClosetCheckBoxProperty,
          renovatedCheckBoxProperty,
          waterFeeBasis,
          renovations,
          damages,
          notes
        },
        { skipUpdate: true }
      )

      if (generatedNotes) {
        changeFormValue('notes', generatedNotes)
      } else {
        console.error('AI generation failed')
      }
    } catch (e) {
      console.error('Error generating AI content:', e)
    } finally {
      setLoading(false)
    }
  }

  {
    return (
      <form onSubmit={handleSubmit(updateApartmentInformation)}>
        <Grid container>
          {' '}
          <Grid container>
            {' '}
            {currentStep === 0 && (
              <>
                <Grid container>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <Grid className={classes.largeForm} container>
                      <List style={{ marginBottom: '40px' }}>
                        <ListItem style={{ paddingLeft: '0', paddingBottom: '4px' }}>
                          <ListItemIcon>
                            <img src={tick} />
                          </ListItemIcon>
                          <ListItemText
                            style={{ display: 'flex', alignItems: 'center' }}
                            primary={t('apartment.tick-0')}
                          // secondary={
                          //   <Dialog
                          //     dialogId='apartmentLink0'
                          //     buttonLabel={
                          //       <>
                          //         <span
                          //           className={classes.readMoreButtonText}
                          //         >
                          //           {t('apartment.tick-4-link')}
                          //         </span>
                          //         <span> &nbsp;&#9432;</span>
                          //       </>
                          //     }
                          //     buttonClassName={classes.readMoreButton}
                          //     Content={<FirstLinkModal t={t} />}
                          //     customCloseIcon={customCloseIcon}
                          //     borderRadius='10px'
                          //     maxWidth='md'
                          //   />
                          // }
                          />
                        </ListItem>
                        <ListItem style={{ paddingLeft: '0', paddingBottom: '4px' }}>
                          <ListItemIcon>
                            <img src={tick} />
                          </ListItemIcon>
                          <ListItemText
                            style={{ display: 'flex', alignItems: 'center' }}
                            primary={t('apartment.tick-1')}
                          // secondary={
                          //   <Dialog
                          //     dialogId='apartmentLink1'
                          //     buttonLabel={
                          //       <>
                          //         <span
                          //           className={classes.readMoreButtonText}
                          //         >
                          //           {t('apartment.tick-4-link')}
                          //         </span>
                          //         <span> &nbsp;&#9432;</span>
                          //       </>
                          //     }
                          //     buttonClassName={classes.readMoreButton}
                          //     Content={<SecongLinkModal t={t} />}
                          //     customCloseIcon={customCloseIcon}
                          //     borderRadius='10px'
                          //     maxWidth='md'
                          //   />
                          // }
                          />
                        </ListItem>
                        <ListItem style={{ paddingLeft: '0', paddingBottom: '4px' }}>
                          <ListItemIcon>
                            <img src={tick} />
                          </ListItemIcon>
                          <ListItemText
                            style={{ display: 'flex', alignItems: 'center' }}
                            primary={t('apartment.tick-2')}
                          // secondary={
                          //   <Dialog
                          //     dialogId='apartmentLink2'
                          //     buttonLabel={
                          //       <>
                          //         <span
                          //           className={classes.readMoreButtonText}
                          //         >
                          //           {t('apartment.tick-4-link')}
                          //         </span>
                          //         <span> &nbsp;&#9432;</span>
                          //       </>
                          //     }
                          //     buttonClassName={classes.readMoreButton}
                          //     Content={<ThirdLinkModal t={t} />}
                          //     customCloseIcon={customCloseIcon}
                          //     borderRadius='10px'
                          //     maxWidth='md'
                          //   />
                          // }
                          />
                        </ListItem>
                        <ListItem style={{ paddingLeft: '0', paddingBottom: '4px' }}>
                          <ListItemIcon>
                            <img src={tick} />
                          </ListItemIcon>
                          <ListItemText
                            style={{ display: 'flex', alignItems: 'center' }}
                            primary={t('apartment.tick-3')}
                          // secondary={
                          //   <Dialog
                          //     dialogId='apartmentLink3'
                          //     buttonLabel={
                          //       <>
                          //         <span
                          //           className={classes.readMoreButtonText}
                          //         >
                          //           {t('apartment.tick-4-link')}
                          //         </span>
                          //         <span> &nbsp;&#9432;</span>
                          //       </>
                          //     }
                          //     buttonClassName={classes.readMoreButton}
                          //     Content={<FourLinkModal t={t} />}
                          //     customCloseIcon={customCloseIcon}
                          //     borderRadius='10px'
                          //     maxWidth='md'
                          //   />
                          // }
                          />
                        </ListItem>
                        <ListItem style={{ paddingLeft: '0', paddingBottom: '4px' }}>
                          <ListItemIcon>
                            <img src={tick} />
                          </ListItemIcon>
                          <ListItemText
                            style={{ display: 'flex', alignItems: 'center' }}
                            primary={t('apartment.tick-4')}
                          // secondary={
                          //   <Dialog
                          //     dialogId='apartmentLink3'
                          //     buttonLabel={
                          //       <>
                          //         <span
                          //           className={classes.readMoreButtonText}
                          //         >
                          //           {t('apartment.tick-4-link')}
                          //         </span>
                          //         <span> &nbsp;&#9432;</span>
                          //       </>
                          //     }
                          //     buttonClassName={classes.readMoreButton}
                          //     Content={<FourLinkModal t={t} />}
                          //     customCloseIcon={customCloseIcon}
                          //     borderRadius='10px'
                          //     maxWidth='md'
                          //   />
                          // }
                          />
                        </ListItem>
                      </List>
                      <Grid item sm={12}>
                        <Typography
                          variant='h5'
                          className={classes.firstStepHeading}
                          gutterBottom
                        >
                          {t('apartment.steps.step0heading')}
                        </Typography>
                      </Grid>{' '}
                      <Grid item xs={12}>
                        <Field
                          name='buildingType'
                          validate={[required]}
                          component={MyApartmentRadio}
                          required
                          style={{ height: '58px' }}
                          disabled={isDisabled}
                          items={getValuesAndLabels(
                            BuildingTypeOptions,
                            'buildingType'
                          ).map(({ value, label }) => [value, t(label)])}
                        />
                      </Grid>
                    </Grid>
                    {isEmpty && (
                      <div className={classes.validationContainer}>
                        <Typography style={{ color: 'red' }} variant='body1'>
                          {t('apartment.actions.stepFail')}
                        </Typography>
                      </div>
                    )}
                    <Grid container className={classes.buttonContainer}>
                      <NextStepButton
                        type='button'
                        beforeLogin={beforeLogin}
                        setIsEmpty={setIsEmpty}
                        toValidate={{
                          buildingType: buildingInfo.buildingType
                        }}
                      />
                    </Grid>
                  </Grid>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                    <div className={classes.infoBoxWrapper}>
                      <Suggest desktopMaxWidth="450px" content={t('apartment.hints.step0Hint')}
                        containerMaxWidth='550px'
                        contentMaxWidth='450px'
                      />
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
            {currentStep === 1 && (
              <Grid container>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Grid className={classes.largeForm} container>
                    <Grid item sm={12}>
                      <Typography variant='h5' gutterBottom>
                        {t('apartment.steps.step1heading')}
                      </Typography>
                    </Grid>{' '}
                    <Grid
                      className={classes.containerItem}
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography variant='body1' align='left' gutterBottom>
                        {t('apartment.rooms.label')}
                      </Typography>
                      <Field
                        name='rooms'
                        validate={[required]}
                        component={MyApartmentRadio}
                        required
                        style={{ height: '58px' }}
                        disabled={isDisabled}
                        items={getValuesAndLabels(
                          RoomOptions,
                          'rooms'
                        ).map(({ value, label }) => [value, t(label)])}
                      />
                    </Grid>
                    <Grid
                      className={classes.containerItem}
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography variant='body1' align='left' gutterBottom>
                        {t('apartment.kitchen.label')}
                      </Typography>
                      <Field
                        name='kitchen'
                        validate={[required]}
                        component={MyApartmentRadio}
                        required
                        style={{ height: '58px' }}
                        disabled={isDisabled}
                        items={getValuesAndLabels(
                          KitchenOptions,
                          'kitchen'
                        ).map(({ value, label }) => [value, t(label)])}
                      />
                    </Grid>
                  </Grid>
                  {isEmpty && (
                    <div className={classes.validationContainer}>
                      <Typography style={{ color: 'red' }} variant='body1'>
                        {t('apartment.actions.stepFail')}
                      </Typography>
                    </div>
                  )}
                  <Grid container className={classes.buttonContainer}>
                    <Grid item xs={4}>
                      <BackButton
                        currentStep={currentStep}
                        doStepBack={doStepBack}
                      />
                    </Grid>
                    <Grid item xs={8}>
                      <NextStepButton
                        type='button'
                        beforeLogin={beforeLogin}
                        setIsEmpty={setIsEmpty}
                        toValidate={{
                          kitchen: propertyInfoValues.kitchen,
                          rooms: propertyInfoValues.rooms
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <div className={classes.infoBoxWrapper}>
                    <Suggest desktopMaxWidth="450px" content={t('apartment.hints.step1Hint')}
                      containerMaxWidth='550px'
                      contentMaxWidth='450px'
                    />
                  </div>
                </Grid>
              </Grid>
            )}
            {currentStep === 2 && (
              <Grid container>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Grid className={classes.largeForm} container>
                    {' '}
                    <Grid item sm={12}>
                      <Typography variant='h5' gutterBottom>
                        {t('apartment.steps.step2heading')}
                      </Typography>
                    </Grid>
                    <Grid
                      className={classes.containerItem}
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography variant='body1' align='left' gutterBottom>
                        {t('apartment.balcony.label')}
                      </Typography>
                      <Field
                        name='balcony'
                        validate={[required]}
                        component={MyApartmentRadio}
                        required
                        style={{ height: '58px' }}
                        disabled={isDisabled}
                        items={getValuesAndLabels(
                          BalconyOptions,
                          'balcony'
                        ).map(({ value, label }) => [value, t(label)])}
                      />
                    </Grid>
                    <Grid
                      className={classes.containerItem}
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography variant='body1' align='left' gutterBottom>
                        {t('apartment.condition.label')}
                      </Typography>
                      <Field
                        name='condition'
                        validate={[required]}
                        component={MyApartmentRadio}
                        required
                        style={{ height: '58px' }}
                        disabled={isDisabled}
                        items={getValuesAndLabels(
                          ConditionOptions,
                          'condition'
                        ).map(({ value, label }) => [value, t(label)])}
                      />
                    </Grid>
                    {isEmpty && (
                      <div className={classes.validationContainer}>
                        <Typography style={{ color: 'red' }} variant='body1'>
                          {t('apartment.actions.stepFail')}
                        </Typography>
                      </div>
                    )}
                  </Grid>
                  <Grid container className={classes.buttonContainer}>
                    <Grid item xs={4}>
                      <BackButton
                        currentStep={currentStep}
                        doStepBack={doStepBack}
                      />
                    </Grid>
                    <Grid item xs={8}>
                      <NextStepButton
                        beforeLogin={beforeLogin}
                        type='button'
                        setIsEmpty={setIsEmpty}
                        toValidate={{
                          condition: propertyInfoValues.condition,
                          balcony: propertyInfoValues.balcony
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <div className={classes.infoBoxWrapper}>
                    <Suggest desktopMaxWidth="450px" content={t('apartment.hints.step1Hint')}
                      containerMaxWidth='550px'
                      contentMaxWidth='450px'
                    />
                  </div>
                </Grid>
              </Grid>
            )}
            {currentStep === 3 && (
              <>
                <Grid container>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                    <Grid className={classes.largeForm} container>
                      {' '}
                      <Grid item xs={12}>
                        <Typography variant='h5' gutterBottom>
                          {t('apartment.steps.step3heading')}
                        </Typography>
                      </Grid>
                      <Grid
                        className={classes.containerItem}
                        item
                        xs={12}
                        sm={12}
                      >
                        <Typography variant='body1' gutterBottom>
                          {t('apartment.dishwasher.label')}
                        </Typography>
                        <Field
                          name='dishwasher'
                          select
                          component={MyApartmentRadio}
                          required
                          validate={[required]}
                          disabled={isDisabled}
                          items={getValuesAndLabels(
                            DishwasherOptions,
                            'dishwasher'
                          ).map(({ value, label }) => [value, t(label)])}
                        />
                      </Grid>
                      <Grid
                        className={classes.containerItem}
                        item
                        xs={12}
                        sm={12}
                      >
                        <Typography variant='body1' gutterBottom>
                          {t('apartment.laundryMachine.label')}
                        </Typography>
                        <Field
                          name='laundryMachine'
                          select
                          component={MyApartmentRadio}
                          required
                          validate={[required]}
                          disabled={isDisabled}
                          items={getValuesAndLabels(
                            LaundryMachineOptions,
                            'laundryMachine'
                          ).map(({ value, label }) => [value, t(label)])}
                        />
                      </Grid>
                      <Grid
                        className={classes.containerItem}
                        item
                        xs={12}
                        sm={12}
                      >
                        <Typography variant='body1' gutterBottom>
                          {t('apartment.waterFeeBasis.label')}
                        </Typography>
                        <ReduxFormField
                          name='waterFeeBasis'
                          select
                          component={MyApartmentRadio}
                          required
                          style={{
                            width: '33%'
                          }}
                          validate={[required]}
                          disabled={isDisabled}
                          items={getValuesAndLabels(
                            WaterFeeBasisOptions,
                            'waterFeeBasis'
                          ).map(({ value, label }) => [value, t(label)])}
                        />
                      </Grid>
                      {waterFeeBasis && showWaterFee(waterFeeBasis) && (
                        <Grid
                          className={classes.containerItem}
                          item
                          xs={4}
                          sm={4}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t(
                              waterFeeBasis === 'metered'
                                ? 'apartment.advanceWaterFee'
                                : 'apartment.waterFee'
                            )}
                          </Typography>
                          <ReduxFormField
                            name='waterFee'
                            type='number'
                            normalize={onlyNumsAndDecimals}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            validate={
                              WaterFeeBasisOptions.metered
                                ? [isInvalidCharacters]
                                : [required, isInvalidCharacters]
                            }
                            required={
                              WaterFeeBasisOptions.metered ? undefined : true
                            }
                            disabled={isDisabled}
                            InputProps={{
                              min: 0,
                              step: 0.01,
                              endAdornment: getWaterFeeAdornment(waterFeeBasis)
                            }}
                            InputIcon='€'
                          />
                        </Grid>
                      )}
                    </Grid>
                    {isEmpty && (
                      <div className={classes.validationContainer}>
                        <Typography style={{ color: 'red' }} variant='body1'>
                          {t('apartment.actions.stepFail')}
                        </Typography>
                      </div>
                    )}
                    <Grid container className={classes.buttonContainer}>
                      <Grid item xs={4}>
                        <BackButton
                          currentStep={currentStep}
                          doStepBack={doStepBack}
                        />
                      </Grid>
                      <Grid item xs={8}>
                        <NextStepButton
                          type='button'
                          beforeLogin={beforeLogin}
                          toValidate={{
                            dishwasher: additionalProps.dishwasher,
                            laundryMachine: additionalProps.laundryMachine,
                            waterFeeBasis: waterFeeBasis
                          }}
                          setIsEmpty={setIsEmpty}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <div className={classes.infoBoxWrapper}>
                      <Suggest desktopMaxWidth="450px" content={t('apartment.hints.step3Hint')}
                        containerMaxWidth='550px'
                        contentMaxWidth='450px'
                      />
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
            {currentStep === 4 && (
              <>
                <Grid container>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <Grid className={classes.largeForm} container>
                      {' '}
                      <Grid item xs={12}>
                        <Typography variant='h5' gutterBottom>
                          {t('apartment.steps.step4heading')}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.containerItem} xs={12}>
                        <CheckBoxProperties t={t} isDisabled={isDisabled} />
                      </Grid>
                    </Grid>
                    {isEmpty && (
                      <div className={classes.validationContainer}>
                        <Typography style={{ color: 'red' }} variant='body1'>
                          {t('apartment.actions.stepFail')}
                        </Typography>
                      </div>
                    )}
                    <Grid container className={classes.buttonContainer}>
                      <Grid item xs={4}>
                        <BackButton
                          currentStep={currentStep}
                          doStepBack={doStepBack}
                        />
                      </Grid>
                      <Grid item xs={8}>
                        <NextStepButton
                          type='button'
                          beforeLogin={beforeLogin}
                          // toValidate={{ notes: notes }}
                          setIsEmpty={setIsEmpty}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <div className={classes.infoBoxWrapper}>
                      {' '}
                      <Suggest desktopMaxWidth="450px" content={t('apartment.hints.step4Hint')}
                        containerMaxWidth='550px'
                        contentMaxWidth='450px'
                      />
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
            {currentStep === 5 && (
              <>
                <Grid container>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <Grid className={classes.largeForm} container>
                      <Grid item xs={12}>
                        <Typography variant='h5' gutterBottom>
                          {t('apartment.steps.step5heading')}
                        </Typography>
                      </Grid>{' '}
                      <Grid container spacing={1}>
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={6}
                        >
                          <Typography variant='body1' align='left' gutterBottom>
                            {t('apartment.rentPrice')}
                          </Typography>
                          <Field
                            name='price'
                            normalize={onlyNumsAndDecimals}
                            type='number'
                            validate={[required]}
                            required
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            disabled={isDisabled}
                            InputProps={{
                              min: 0,
                              step: 0.1,
                              endAdornment: 'm²'
                            }}
                            InputIcon='€'
                          />
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={6}
                        >
                          <Typography variant='body1' align='left' gutterBottom>
                            {t('apartment.squareMeters')}
                          </Typography>
                          <Field
                            name='squareMeters'
                            normalize={onlyNumsAndDecimals}
                            type='number'
                            validate={[required]}
                            required
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            disabled={isDisabled}
                            InputIcon='m²'
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          className={classes.containerItem}
                        >
                          <Typography variant='body1' align='left' gutterBottom>
                            {t('apartment.buildYear')}
                          </Typography>
                          <Field
                            name='buildYear'
                            normalize={onlyNums}
                            type='number'
                              inputProps={{ min: 1699, max: 2050 }}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                              validate={[required, validateYear, yearAtLeast1699]}
                            required
                            disabled={isDisabled}
                          />
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          sm={3}
                          xs={6}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('apartment.floor')}
                          </Typography>
                          <ReduxFormField
                            name='floor'
                            type='number'
                            //normalize={onlyNums}
                            inputProps={{ step: 1 }}
                            validate={[lessOrEqualThanFloors, isNumericOrEmpty]}
                            disabled={isDisabled}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          sm={3}
                          xs={6}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('apartment.floors')}
                          </Typography>
                          <ReduxFormField
                            name='floors'
                            type='number'
                            //normalize={onlyNums}
                            inputProps={{ min: 0, step: 1 }}
                            validate={[moreOrEqualThanFloor, isNumericOrEmpty]}
                            disabled={isDisabled}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={12}
                          sm={12}
                        >
                          {' '}
                          <Typography variant='body1' gutterBottom>
                            {t('apartment.availableFromDate')}
                          </Typography>
                          <Grid item xs={12} className={classes.datePicker}>
                            {' '}
                            <DateRangeIcon />
                            <ReduxFormField
                              fullWidth
                              name='availableFromDate'
                              validate={[lessThanAvailableUntil]}
                              component={ReduxDatePicker}
                              disabled={isDisabled}
                            />
                          </Grid>
                        </Grid>
                        {/* <Grid item xs={12}>
                          <AdditionalInfoFields
                            t={t}
                            currentStep={currentStep}
                            classes={classes}
                            isDisabled={isDisabled}
                          />
                        </Grid> */}
                      </Grid>
                    </Grid>
                    {isEmpty && (
                      <div className={classes.validationContainer}>
                        <Typography style={{ color: 'red' }} variant='body1'>
                          {t('apartment.actions.stepFail')}
                        </Typography>
                      </div>
                    )}
                    <Grid container className={classes.buttonContainer}>
                      <Grid item xs={4}>
                        <BackButton
                          currentStep={currentStep}
                          doStepBack={doStepBack}
                        />
                      </Grid>

                      <Grid item xs={8}>
                        <NextStepButton
                          type='button'
                          beforeLogin={beforeLogin}
                          toValidate={{
                            squareMeters: propertyInfoValues.squareMeters,
                            price: propertyInfoValues.price,
                            buildYear: buildingInfo.buildYear
                          }}
                          const toCheck={{
                              buildYear: validateYear(`${buildingInfo.buildYear}`) || yearAtLeast1699(`${buildingInfo.buildYear}`),
                            floorNotExceedingFloors: lessOrEqualThanFloors(`${addressInfoValues.floor}`, addressInfoValues),
                            floorIsNumeric: isNumericOrEmpty(`${addressInfoValues.floor}`),
                            floorsNotBelowFloor: moreOrEqualThanFloor(`${addressInfoValues.floors}`, addressInfoValues),
                            floorsIsNumeric: isNumericOrEmpty(`${addressInfoValues.floors}`)
                          }
                          }
                          setIsEmpty={setIsEmpty}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <div className={classes.infoBoxWrapper}>
                      <Suggest desktopMaxWidth="450px" content={t('apartment.hints.step5Hint')}
                        containerMaxWidth='550px'
                        contentMaxWidth='450px'
                      />
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
            {currentStep === 6 && (
              <>
                <Grid container>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <Grid
                      className={classes.largeForm}
                      justify='space-between'
                      container
                    >
                      <Grid container spacing={1}>
                        <Grid item sm={12}>
                          <Typography variant='h5' gutterBottom>
                            {t('apartment.steps.step6heading')}
                          </Typography>
                        </Grid>

                        <Grid
                          item
                          className={classes.containerItem}
                          xs={12}
                          sm={8}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('person.streetAddress')}
                          </Typography>
                          <Field
                            fullWidth
                            //normalize={charsSpace}
                            name='autocompleteLocation'
                            selectLabel={t('autocomplete.select')}
                            existingLocations={[]}
                            placeholder={t('autocomplete.placeholder')}
                            changeFormValue={changeFormValue}
                            streetNumberFormValue={streetNumber}
                            component={ReduxGoogleAutocomplete}
                            validate={[requiredLocation]}
                            required
                            isFromApartmentForm={true}
                            normalize={(val: string) => (typeof val === 'string' ? val.replace(/^\s+/, '') : val)}
                          />
                          {/*
                          <ReduxFormField
                            name='autocompleteLocation'
                            selectLabel={t('autocomplete.select')}
                            normalize={charsSpace}
                            changeFormValue={changeFormValue}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            validate={[requiredLocation]}
                            required
                          /> */}
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={4}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('person.streetNumber')}
                          </Typography>
                          <ReduxFormField
                            name='streetNumber'
                            normalize={onlyNums}
                            defaultValue=''
                            min={0}
                            validate={[required, isStreetNumber]}
                            disabled={isDisabled}
                            required
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={6}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('person.buildingLetterAndApartmentNumber')}
                          </Typography>
                          <ReduxFormField
                            name='buildingLetter'
                            defaultValue=''
                            validate={[isInvalidCharacters]}
                            disabled={isDisabled}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                          />
                        </Grid>
                        {/* <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={3}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('person.apartment')}
                          </Typography>
                          <ReduxFormField
                            name='apartmentNumber'
                            normalize={onlyNums}
                            disabled={isDisabled}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                          />
                        </Grid> */}
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={6}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('person.postalCode')}
                          </Typography>
                          <ReduxFormField
                            name='postalCode'
                            //set default value to prevent react error: A component is changing an uncontrolled input to be controlled.
                            defaultValue=''
                            normalize={onlyNums}
                            min={0}
                            validate={[required, isPostalCode]}
                            disabled={isDisabled}
                            required
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={6}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('person.postalArea')}
                          </Typography>
                          <ReduxFormField
                            name='postalArea'
                            validate={[validatePostalArea]}
                            disabled={isDisabled}
                            options={arrayOfCities}
                            component={ReduxFormSelect}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            required
                          />
                          {/* {arrayOfCities.map((value) => (
                            <MenuItem key={value} value={value}>
                              {t(value)}
                            </MenuItem>
                          ))}
                          </ReduxFormField> */}
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={6}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('person.district')}
                          </Typography>
                          <ReduxFormField
                            name='district'
                            defaultValue=''
                            normalize={charsSpace}
                            validate={[required]}
                            disabled={isDisabled}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    {isEmpty && (
                      <Typography style={{ color: 'red' }} variant='body1'>
                        {t('apartment.actions.stepFail')}
                      </Typography>
                    )}
                    <Grid container>
                      <ErrorMessage error={error} />
                      <Grid container className={classes.buttonContainer}>
                        <Grid item xs={4}>
                          <BackButton
                            currentStep={currentStep}
                            doStepBack={doStepBack}
                          />
                        </Grid>
                        <Grid item xs={8}>
                          <NextStepButton
                            type='button'
                            beforeLogin={beforeLogin}
                            toValidate={{
                              autocompleteLocation:
                                addressInfoValues.autocompleteLocation,
                              postalArea: addressInfoValues.postalArea,
                              postalCode: addressInfoValues.postalCode,
                              streetNumber: addressInfoValues.streetNumber
                            }}
                            toCheck={{
                              streetNumber: isStreetNumber(
                                `${addressInfoValues.streetNumber}`
                              ),
                              buildingLetter: isInvalidCharacters(
                                `${addressInfoValues.buildingLetter}`
                              ),
                              postalCode: isPostalCode(
                                `${addressInfoValues.postalCode}`
                              )
                            }}
                            setIsEmpty={setIsEmpty}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <div className={classes.infoBoxWrapper}>
                      {' '}
                      <Suggest desktopMaxWidth="450px" content={t('apartment.hints.step6Hint')}
                        containerMaxWidth='550px'
                        contentMaxWidth='450px'
                      />
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
            {currentStep === 7 && (
              <>
                <Grid container>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <Grid className={classes.largeForm} container>
                      <Grid item xs={12}>
                        <Typography variant='h5' gutterBottom>
                          {t('apartment.steps.step7heading')}
                        </Typography>
                      </Grid>
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
          <AdditionalInfoFields
            t={t}
            currentStep={currentStep}
            classes={classes}
            isDisabled={isDisabled || isLoading}
            isLoading={isLoading}
          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} className={classes.tabletMaxWidth} style={{ marginBottom: '20px' }}>
                      <Button
                        onClick={handleGenerateAIText}
                        disabled={isDisabled || isLoading}
                        style={{
                          color: '#000000',
                          border: '1px solid #C4C4C4',
                          padding: '7px 12px 7px 12px',
                          fontSize: '0.8125rem',
                          boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
                          textTransform: 'none',
                          backgroundColor: '#FFFFFF'
                        }}
                        variant='contained'
                      >
                        {'Luonnostele esittelyteksti (AI)'}
                      </Button>
                    </Grid>

                    {isEmpty && (
                      <div className={classes.tabletMaxWidth}>
                        <Typography style={{ color: 'red' }} variant='body1'>
                          {t('apartment.actions.stepFail')}
                        </Typography>
                      </div>
                    )}

                    <Grid container className={classes.buttonContainer}>

                      <Grid item xs={4}>
                        <BackButton
                          disabled={isLoading}
                          currentStep={currentStep}
                          doStepBack={doStepBack}
                        />
                      </Grid>

                      <Grid item xs={8}>
                        <NextStepButton
                          type='button'
                          beforeLogin={beforeLogin}
                          disabled={isLoading}
                          toValidate={{
                            notes: notes
                          }}
                          toCheck={{
                            notes: isInvalidCharacters(notes)
                          }}
                          setIsEmpty={setIsEmpty}
                        />
                      </Grid>

                    </Grid>
                  </Grid>

                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <div className={classes.infoBoxWrapper}>
                      <Suggest desktopMaxWidth="450px" content={t('apartment.hints.step7Hint')}
                        containerMaxWidth='550px'
                        contentMaxWidth='450px'
                      />
                    </div>
                  </Grid>
                </Grid>
              </>


            )}
            {currentStep === 8 && (
              <>
                <Grid container>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <Grid className={classes.largeForm} container>
                      <Grid item xs={12}>
                        <Typography variant='h5' gutterBottom>
                          {t('apartment.steps.step8heading')}
                        </Typography>
                      </Grid>{' '}
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <Grid container className={classes.containerItem}>
                            <Grid item xs={12} sm={12}>
                              <Typography variant='body1' gutterBottom>
                                {t('apartment.list.information.pastRenovations')}
                              </Typography>
                              <ReduxFormField
                                name='damages'
                                multiline={true}
                                component={MyTextArea}
                                validate={[isInvalidCharacters]}
                                style={{
                                  width: '100%',
                                  height: '105px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                                required
                              />
                            </Grid>
                          </Grid>
                          <Grid container className={classes.containerItem}>
                            <Grid item xs={12} sm={12}>
                              <Typography variant='body1' gutterBottom>
                                {t('apartment.list.information.futureRenovations')}
                              </Typography>
                              <ReduxFormField
                                name='renovations'
                                multiline={true}
                                disabled={isDisabled}
                                component={MyTextArea}
                                validate={[isInvalidCharacters]}
                                style={{
                                  width: '100%',
                                  height: '105px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                              />
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            className={classes.containerItem}
                            xs={12}
                            sm={12}
                          >
                            <Typography variant='body1' gutterBottom>
                              {t('apartment.list.information.energyCertification')}
                            </Typography>
                            <ReduxFormField
                              name='energyCertification'
                              required
                              validate={[required]}
                              options={energyCertifications}
                              disabled={isDisabled}
                              component={ReduxFormSelect}
                              style={{
                                width: '100%',
                                height: '58px',
                                padding: '20px',
                                background: '#E7ECEF'
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    {isEmpty && (
                      <Typography style={{ color: 'red' }} variant='body1'>
                        {t('apartment.actions.stepFail')}
                      </Typography>
                    )}
                    <Grid container className={classes.buttonContainer}>
                      <Grid item xs={4}>
                        <BackButton
                          disabled={isLoading}
                          currentStep={currentStep}
                          doStepBack={doStepBack}
                        />
                      </Grid>

                      <Grid item xs={8}>
                        <SubmitButton
                          setIsEmpty={setIsEmpty}
                          toCheck={{
                            damages: isInvalidCharacters(damages),
                            renovations: isInvalidCharacters(renovations)
                          }}
                          t={t}
                          submit={true}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <div className={classes.infoBoxWrapper}>
                      <Suggest desktopMaxWidth="450px" content={t('apartment.hints.step8Hint')}
                        containerMaxWidth='550px'
                        contentMaxWidth='450px'
                      />
                    </div>
                  </Grid>
                </Grid>
              </>
            )}

          </Grid>
        </Grid>
      </form>
    )
  }
}

const selector = formValueSelector('ApartmentInformationForm')

const mapStateToProps = (state: StateInterface) => ({
  // address information
  autocompleteLocation: selector(state, 'autocompleteLocation'),
  postalArea: selector(state, 'postalArea'),
  postalCode: selector(state, 'postalCode'),
  streetNumber: selector(state, 'streetNumber'),
  district: selector(state, 'district'),
  //apartmentNumber: selector(state, 'apartmentNumber'),
  buildingLetter: selector(state, 'buildingLetter'),
  // size information
  rooms: selector(state, 'rooms'),
  kitchen: selector(state, 'kitchen'),
  storage: selector(state, 'storage'),
  balcony: selector(state, 'balcony'),
  condition: selector(state, 'condition'),
  price: selector(state, 'price'),
  // building information
  squareMeters: selector(state, 'squareMeters'),
  buildYear: selector(state, 'buildYear'),
  floor: selector(state, 'floor'),
  floors: selector(state, 'floors'),
  availableFromDate: selector(state, 'availableFromDate'),
  buildingType: selector(state, 'buildingType'),
  // additional properties
  waterFeeBasis: selector(state, 'waterFeeBasis'),
  waterFee: selector(state, 'waterFee'),
  heating: selector(state, 'heating'),
  sauna: selector(state, 'sauna'),
  parking: selector(state, 'parking'),
  petsAllowed: selector(state, 'petsAllowed'),
  dishwasher: selector(state, 'dishwasher'),
  laundryMachine: selector(state, 'laundryMachine'),
  notes: selector(state, 'notes'),
  damages: selector(state, 'damages'),
  renovations: selector(state, 'renovations'),
  energyCertification: selector(state, 'energyCertification'),
  internetIncluded: selector(state, 'internetIncluded'),
  // newly added properties
  renovatedCheckBoxProperty: selector(state, 'renovatedCheckBoxProperty'),
  hasElevator: selector(state, 'hasElevator'),
  isFurnished: selector(state, 'isFurnished'),
  hasBuiltInClosetCheckBoxProperty: selector(state, 'hasBuiltInClosetCheckBoxProperty'),
  hasSaunaCheckBoxProperty: selector(state, 'hasSaunaCheckBoxProperty'),
  petsAllowedCheckBoxProperty: selector(state, 'petsAllowedCheckBoxProperty'),
  housingPropertySauna: selector(state, 'housingPropertySauna'),
  newProperty: selector(state, 'newProperty'),
});


const mapDispatchToProps = (dispatch: Dispatch) => ({
  changeFormValue: (field: string, value: string) =>
    dispatch(change('ApartmentInformationForm', field, value)),
  doNextStep: (beforeLogin: boolean) => dispatch(stepForward({ beforeLogin }))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'ApartmentInformationForm',
    initialValues: {
      laundryMachine: 'room'
    }
  })(withTranslation()(ApartmentInformationForm as any) as any) as any
) as any
